module.exports = __webpack_public_path__ + "static/img/show_pic8.b97683df.png";